<template>
  <div class="free-trial">
    <div class="free-trial__dialog-wrapper">
      <div class="free-trial__dialog">
        <div class="free-trial__dialog-title">
          Try Premium or either Fundamentals Subscriptions for Free!
        </div>
        <div class="free-trial__dialog-subtitle">7-Day risk free trial. Cancel anytime.</div>
        <div class="free-trial__dialog-plans">
          <PlanFreeTrialCard
            v-for="plan in freeTrialPlans"
            :key="plan.id"
            :plan="plan"
            class="free-trial__dialog-plans-card"
            @start-free-trial-plan="startFreeTrialHandler"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import PlanFreeTrialCard from '@/components/PlanRowItemFreeTrialCard.vue'

export default {
  name: 'FreeTrial',
  components: {
    PlanFreeTrialCard,
  },
  methods: {
    ...mapActions({
      addProductToShoppingCart: 'shoppingCart/addProductToShoppingCart',
      removeFromShoppingCart: 'shoppingCart/removeProductFromShoppingCart',
    }),
    clearCart() {
      this.shoppingCart.forEach(item => this.removeFromShoppingCart(item))
    },
    startFreeTrialHandler(plan) {
      this.clearCart()
      plan.plan_trial = true
      this.addProductToShoppingCart(plan)
      this.$router.push({ name: this.userProfile.email ? 'payment' : 'account' })
    },
  },
  computed: {
    ...mapState({
      shoppingCart: state => state.shoppingCart.shoppingCart,
      userProfile: state => state.auth.userProfile,
    }),
    ...mapGetters({
      plans: 'products/plansByTerm',
    }),
    freeTrialPlans() {
      const plans = []
      const planIterator = plan => {
        if (plan.free_trial_eligible) {
          plans.push(plan)
        }
      }
      this.plans.monthly.forEach(planIterator)
      this.plans.yearly.forEach(planIterator)
      // workaround to fix plans render order
      if (!plans.length || !plans[1]) return plans
      const premiumPlan = plans[1]
      plans[1] = plans[0]
      plans[0] = premiumPlan
      return plans
    },
  },
}
</script>
<style lang="scss">
.free-trial {
  color: var(--white);
  font-family: var(--font-regular);
  &__dialog {
    &-wrapper {
      padding-top: 3%;
      -webkit-transition: 0.5s;
      overflow: auto;
      transition: all 0.3s linear;
      @media screen and (max-width: 1236px) {
        padding-top: 0;
      }
      @include lg-desktop {
        min-height: 100vh;
      }
    }
    padding: 30px;
    max-width: 1120px;
    margin: auto;
    border-radius: 20px;
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    padding-bottom: 15vh;
    @include mobile {
      padding-bottom: 45vh;
    }
    @include desktop {
      padding-bottom: 30px;
    }
    &-btn-close {
      border-radius: 20px;
      align-self: flex-end;
      padding: 0;
      @include mobile {
        padding: 24px;
      }
    }
    &-title {
      font-weight: 700;
      font-size: 20px;
      line-height: 26px;
      margin-bottom: 20px;
      text-align: center;
      @include mobile {
        font-size: 32px;
        line-height: 38px;
        width: 75%;
      }
      @include desktop {
        font-size: 40px;
        line-height: 52px;
        width: 65%;
      }
    }
    &-subtitle {
      color: var(--deactivated-feature);
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      margin-bottom: 35px;
      @include mobile {
        margin-bottom: 50px;
        font-size: 18px;
        line-height: 24px;
      }
    }
    &-plans {
      display: flex;
      justify-content: center;
      flex-flow: column;
      row-gap: 20px;
      @include mobile {
        flex-flow: row;
        row-gap: 0;
        column-gap: 20px;
        font-size: 18px;
        line-height: 24px;
      }
    }
  }
}
</style>
